import { withLifeErrorBoundary } from '@festina-life/components'
import { SimpleModal } from '@festina-life/ui/structure'
import { Activity } from 'react'
import {
  Group,
  Panel,
  Separator,
  useDefaultLayout,
} from 'react-resizable-panels'

import { CollapsibleResizeHandle } from '../../components/collapsibleResizeHandle/CollapsibleResizeHandle'
import { DetailsLayout } from '../../components/detailsLayout/DetailsLayout'
import { useLayoutContext } from '../../context/layoutContext'
import { useParameterContext } from '../../context/parameterContext'
import { ParameterDetailsRightSideBar } from '../layout/ParameterDetailsRightSideBar'
import { ParameterDetailsContentSelector } from './parameterDetails/ParameterDetailsContentSelector'
import { ParameterDetailsTitle } from './parameterDetails/ParameterDetailsTitle'
import { ParameterSidebar } from './ParameterSidebar'
import { ParameterViewer } from './parameterViewer/ParameterViewer'
import { ParameterViewerTopBar } from './ParameterViewerTopBar'
import { useNavigateToCurrentParameterDefinitionPath } from './useNavigateToCurrentParameterDefinitionPath'

const ParameterDefinitionInternal = () => {
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    groupId: 'parameterViewerPanel',
    storage: localStorage,
  })
  const { preferences, onChangeView } = useLayoutContext()
  const {
    parameters: { isSidebarOpen },
    common: { isUsingModal },
  } = preferences
  const { viewingDetails } = useParameterContext()
  const navigateToPath = useNavigateToCurrentParameterDefinitionPath()

  const handleToggleSidebar = () => {
    onChangeView({
      ...preferences,
      parameters: { ...preferences.parameters, isSidebarOpen: !isSidebarOpen },
    })
  }

  return (
    <Group
      orientation="horizontal"
      defaultLayout={defaultLayout}
      onLayoutChanged={onLayoutChanged}
      className="size-full"
    >
      <Activity mode={isSidebarOpen ? 'visible' : 'hidden'}>
        <Panel
          defaultSize="20%"
          className="size-full overflow-hidden"
          id="parameterModels"
          minSize="5%"
        >
          <ParameterSidebar />
        </Panel>
      </Activity>
      <CollapsibleResizeHandle
        id="resizeParameterModelsBar"
        isOpen={isSidebarOpen}
        onToggle={handleToggleSidebar}
      />

      <Panel className="size-full overflow-hidden" id="parameterCentralView">
        <div className="size-full flex-1 overflow-hidden">
          <div className="grid size-full grid-rows-[auto_1fr] overflow-hidden">
            <ParameterViewerTopBar />
            <ParameterViewer />
          </div>
        </div>
      </Panel>
      {viewingDetails && !isUsingModal ? (
        <>
          <Separator
            id="resizeParameterDetails"
            className="w-1 dark:bg-slate-700 bg-slate-300"
          />
          <Panel
            id="parameterDetailsPanel"
            className="size-full"
            minSize="5%"
            defaultSize="25%"
          >
            <ParameterDetailsRightSideBar onClose={() => navigateToPath('')} />
          </Panel>
        </>
      ) : (
        <SimpleModal
          isOpen={!!viewingDetails}
          title={<ParameterDetailsTitle data={viewingDetails} />}
          closeConfiguration={{ onClose: () => navigateToPath('') }}
          bodyOuterClassName="xl:w-[50vw]"
          bodyInnerClassName="p-6"
        >
          <DetailsLayout>
            <ParameterDetailsContentSelector data={viewingDetails} />
          </DetailsLayout>
        </SimpleModal>
      )}
    </Group>
  )
}

export const ParameterDefinition = withLifeErrorBoundary(
  ParameterDefinitionInternal,
)
